import { render, staticRenderFns } from "./ElTableColumnCodeDescription.vue?vue&type=template&id=3c2a294a&scoped=true"
import script from "./ElTableColumnCodeDescription.vue?vue&type=script&setup=true&lang=ts"
export * from "./ElTableColumnCodeDescription.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ElTableColumnCodeDescription.vue?vue&type=style&index=0&id=3c2a294a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2a294a",
  null
  
)

export default component.exports